import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

export const useUpdateDeliveryInspection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.deliveries.updateDeliveryInspection>) =>
      API.deliveries.updateDeliveryInspection(...args),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries([QueryKeys.Delivery]),
        queryClient.invalidateQueries([QueryKeys.TimeStamps]),
        queryClient.invalidateQueries([QueryKeys.SurgeryTimeStamps]),
        queryClient.invalidateQueries([QueryKeys.Deliveries]),
      ]),
  });
};
